import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MeetingRoomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"meeting_room"}/>
}
